import React, { Fragment } from 'react';
import styled from 'styled-components';
import { SpacerVertical, Typography, ListPrimary, Link } from '@klarna/bubble-ui';
export const TextWithNewlines = styled.div.withConfig({ displayName: "TextWithNewlines", componentId: "sc-18jchkt" }) `
  white-space: pre-wrap;
`;
const strong = value => (React.createElement(Typography, { textToken: "text-style/text/super-paragraphs/body/bold" }, value));
export const Paragraphs = ({ tKey, params, tArray, }) => {
    const translations = tArray(tKey, Object.assign(Object.assign({}, params), { strong }));
    if (!translations || !translations.length) {
        return null;
    }
    return (React.createElement(React.Fragment, null, translations.map(({ text, list, link }) => (React.createElement(Fragment, { key: text },
        text &&
            (link ? (
            // @ts-expect-error: FIXME
            React.createElement(Link, { href: link, target: "_blank", rel: "noopener noreferrer" }, text)) : (React.createElement(Typography, { textToken: "text-style/text/super-paragraphs/body/regular" },
                React.createElement(TextWithNewlines, null, text)))),
        list && Array.isArray(list) && React.createElement(ListPrimary, { items: list.map(r => r.text) }),
        React.createElement(SpacerVertical, { small: true }))))));
};
